import { integer, snakeCase, text, varchar } from 'drizzle-orm/pg-core'
import { id, timestamps } from '../utils/columns.helpers'
import { categoryStatusEnum } from './_common.table'

export const trustedBrandsTable = snakeCase.table('trusted_brands', {
    id: id('tb'),
    name: varchar({ length: 255 }).notNull(),
    logoUrl: text().notNull(),
    linkUrl: text(),
    status: categoryStatusEnum().notNull().default('active'),
    sortOrder: integer().notNull().default(0),
    ...timestamps,
})
